import { render } from "./RecentActivityTable.vue?vue&type=template&id=68daec6e&scoped=true"
import script from "./RecentActivityTable.vue?vue&type=script&lang=js"
export * from "./RecentActivityTable.vue?vue&type=script&lang=js"

import "./RecentActivityTable.vue?vue&type=style&index=0&id=68daec6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68daec6e"]])

export default __exports__